module.exports = __webpack_public_path__ + "images/GreenSky-128f84.png";